import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Trash2 } from "lucide-react";

export default function AdminFeeRules() {
  const [rules, setRules] = useState([]);
  const [form, setForm] = useState({ name: "", kind: "percent", value: 10, minimum_fee: 0, active: true });
  const load = () => api.get("/fee-rules").then(r => setRules(r.data));
  useEffect(() => { load(); }, []);
  const submit = async (e) => { e.preventDefault(); await api.post("/fee-rules", { ...form, value: Number(form.value), minimum_fee: Number(form.minimum_fee) }); setForm({ name:"", kind:"percent", value:10, minimum_fee:0, active:true }); load(); };
  const remove = async (id) => { await api.delete(`/fee-rules/${id}`); load(); };
  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <div className="text-[11px] tracking-[0.2em] uppercase text-gold font-bold mb-2">Margin engine</div>
        <h1 className="font-display text-4xl font-bold tracking-tighter text-navy">Fee Rules</h1>
      </div>
      <form onSubmit={submit} className="card-base p-6 grid md:grid-cols-5 gap-3" data-testid="fee-rule-form">
        <input className="input-base md:col-span-2" placeholder="Rule name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required data-testid="rule-name" />
        <select className="input-base" value={form.kind} onChange={e => setForm({...form, kind: e.target.value})} data-testid="rule-kind">
          <option value="percent">Percent</option><option value="flat">Flat</option><option value="per_mile">Per mile</option>
        </select>
        <input type="number" step="0.01" className="input-base" placeholder="Value" value={form.value} onChange={e => setForm({...form, value: e.target.value})} required data-testid="rule-value" />
        <button className="btn-primary" data-testid="rule-submit">Add rule</button>
      </form>
      <div className="card-base overflow-x-auto">
        <table className="table-base">
          <thead><tr><th>Name</th><th>Kind</th><th>Value</th><th>Min fee</th><th>Active</th><th></th></tr></thead>
          <tbody>
            {rules.length === 0 && <tr><td colSpan={6} className="text-center py-8 text-slate-400">No rules.</td></tr>}
            {rules.map(r => (
              <tr key={r.rule_id} data-testid={`rule-${r.rule_id}`}>
                <td className="font-semibold">{r.name}</td>
                <td className="capitalize">{r.kind.replace("_"," ")}</td>
                <td className="font-mono">{r.kind === "percent" ? `${r.value}%` : `$${r.value}`}</td>
                <td className="font-mono">${r.minimum_fee}</td>
                <td>{r.active ? <span className="badge accepted">Active</span> : <span className="badge draft">Off</span>}</td>
                <td><button onClick={() => remove(r.rule_id)} className="text-red-600 hover:text-red-800" data-testid={`delete-rule-${r.rule_id}`}><Trash2 size={16} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
